import React, {Component} from 'react';
import {EDIT_MODE} from "../../../../../wpconfig";
import * as func from "../../../../../utils/functions";

class MPProfile extends Component {
	constructor(props) {
		super(props);

		const r = func.deepClone(this.props.record);

		this.state = {
			activeTab : '',
			record : r,
			field : 'my_library/info'
		}
	}

	closePopup = () => {
		this.props.onUpdate(func.deepClone(this.state.record));
		this.props.closePopup('isShowEditProfile')
	}

	change = () => {
		const record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.onUpdate(record);
	}

	onSave = (event) => {
		event.preventDefault()
		func.updateData(this.state.field, this.props.record).then((response) => {
			if (response.code === 'ok') {
				this.setState({record : func.deepClone(this.props.record)})
				// this.props.showMessage('수정 되었습니다.');
				this.props.closePopup('isShowEditProfile')
			} else {
				// this.props.showMessage('수정 실패 : ' + response.message)
			}
		});
	};

	render() {
		const record = this.props.record;
		return (
			<div className="modal show" id="profileModify" tabIndex="-1">
				<div className="modal-dialog modal-smd modal-dialog-centered">
					<div className="modal-content">
						<div className="modal-header">
							<h3 className="con-title">프로필 수정</h3>
						</div>
						<div className="modal-body">
							<div className="form-group">
								<div className="mb-3 row">
									<label htmlFor="staticEmail" className="col-2 pr-0 col-form-label">연구실</label>
									<div className="col-7 d-flex">
										<input type="text" className="form-control" value={record.lab_name || ''}
										       name="lab_name"
										       ref={(ref)=>this.lab_name=ref}
										       onChange={this.change}
										/>
									</div>
								</div>
								<div className="mb-3 row">
									<label htmlFor="staticEmail" className="col-2 pr-0 col-form-label">이메일</label>
									<div className="col-7 d-flex">
										<input type="text" className="form-control" value={record.email || ''}
										       name="email"
										       ref={(ref)=>this.email=ref}
										       onChange={this.change}
										/>
									</div>
								</div>
								<div className="mb-3 row">
									<label htmlFor="staticEmail" className="col-2 pr-0 col-form-label">홈페이지</label>
									<div className="col-7 d-flex">
										<input type="text" className="form-control" value={record.homepage || ''}
										       name="homepage"
										       ref={(ref)=>this.homepage=ref}
										       onChange={this.change}
										/>
									</div>
								</div>
							</div>
							<div className="mt-4 border-top border-lightgray font-size-14 color-lightblack">
								<div className="mt-px-26">상세 연구분야</div>
								<div className="mt-px-10">
									<textarea className="form-control" value={record.research_field || ''}
									       name="research_field"
									       ref={(ref)=>this.research_field=ref}
									       onChange={this.change}
									       placeholder="저자의 상세연구분야를 작성해 주세요."
									/>
								</div>
								<div className="mt-px-18">희망 협업분야</div>
								<div className="mt-px-10">
									<textarea className="form-control" value={record.collabo_field || ''}
									       name="collabo_field"
									       ref={(ref)=>this.collabo_field=ref}
									       onChange={this.change}
									       placeholder="저자의 상세연구분야를 작성해 주세요."
									/>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-outline-gray" onClick={this.closePopup}>
								<strong>취소</strong>
							</button>
							<button type="button" className="btn btn-darkblue" onClick={this.onSave}><strong>저장</strong></button>
						</div>
						<button type="button" className="btn-close" onClick={this.closePopup}/>
					</div>
				</div>
			</div>
		)
	}
};

export default MPProfile;
